
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Our Mission */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-8">{t('about.ourMission.title')}</h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            {t('about.ourMission.description')}
          </p>
        </div>

        {/* Our Values */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 text-center mb-12">{t('about.ourValues.title')}</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-900 mb-3">{t('about.ourValues.transparency.title')}</h3>
              <p className="text-gray-600">{t('about.ourValues.transparency.description')}</p>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-900 mb-3">{t('about.ourValues.innovation.title')}</h3>
              <p className="text-gray-600">{t('about.ourValues.innovation.description')}</p>
            </div>
            
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold text-blue-900 mb-3">{t('about.ourValues.partnership.title')}</h3>
              <p className="text-gray-600">{t('about.ourValues.partnership.description')}</p>
            </div>
          </div>
        </div>

        {/* Our Leadership */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 text-center mb-12">{t('about.ourLeadership.title')}</h2>
          <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            <div className="text-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/c2b5233b86b1b700f5449bef56482984.jpg"
                alt="Ariel - Co-founder and CEO"
                className="w-48 h-48 rounded-full mx-auto mb-6 object-cover object-top"
              />
              <h3 className="text-2xl font-bold text-blue-900 mb-2">Ariel</h3>
              <p className="text-orange-500 font-semibold mb-4">{t('about.ourLeadership.ariel.title')}</p>
              <p className="text-gray-600 leading-relaxed">{t('about.ourLeadership.ariel.description')}</p>
            </div>
            
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20confident%20male%20executive%20in%20modern%20office%20setting%2C%20wearing%20dark%20suit%2C%20friendly%20expression%2C%20clean%20background%2C%20corporate%20headshot%20style%2C%20high%20quality%20photography&width=300&height=300&seq=kysen-coo&orientation=squarish"
                alt="Kysen - Co-founder and COO"
                className="w-48 h-48 rounded-full mx-auto mb-6 object-cover object-top"
              />
              <h3 className="text-2xl font-bold text-blue-900 mb-2">Kysen</h3>
              <p className="text-orange-500 font-semibold mb-4">{t('about.ourLeadership.kysen.title')}</p>
              <p className="text-gray-600 leading-relaxed">{t('about.ourLeadership.kysen.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
